import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UserCircle, Building2, Calendar } from "lucide-react";
import TaskGrid from "./TaskGrid";
import CalendarView from "./CalendarView";

interface Task {
  id: string;
  title: string;
  status: string;
  assignedTo: string;
  date: string;
  location: string;
  priority: string;
  estimatedHours: number;
  taskType: string;
  createdByType: string;
}

interface TaskTabsProps {
  tasks: Task[];
  selectedDate: Date;
  setSelectedDate: (date: Date) => void;
  onEdit: (taskId: string) => void;
  onDelete: (taskId: string) => void;
}

const TaskTabs = ({ tasks, selectedDate, setSelectedDate, onEdit, onDelete }: TaskTabsProps) => {
  const adminTasks = tasks.filter((task) => task.createdByType === 'admin');
  const employeeTasks = tasks.filter((task) => task.createdByType === 'employee');
  
  const getTasksForDate = (date: Date) => {
    return tasks.filter((task) => {
      const taskDate = new Date(task.date);
      return (
        taskDate.getDate() === date.getDate() &&
        taskDate.getMonth() === date.getMonth() &&
        taskDate.getFullYear() === date.getFullYear()
      );
    });
  };

  return (
    <Tabs defaultValue="all" className="w-full">
      <TabsList className="w-full">
        <TabsTrigger value="all" className="flex-1">Alle opgaver</TabsTrigger>
        <TabsTrigger value="admin" className="flex-1">
          <Building2 className="w-4 h-4 mr-2" />
          Admin-oprettede
        </TabsTrigger>
        <TabsTrigger value="employee" className="flex-1">
          <UserCircle className="w-4 h-4 mr-2" />
          Medarbejder-oprettede
        </TabsTrigger>
        <TabsTrigger value="calendar" className="flex-1">
          <Calendar className="w-4 h-4 mr-2" />
          Kalender
        </TabsTrigger>
      </TabsList>

      <TabsContent value="all">
        <TaskGrid tasks={tasks} onEdit={onEdit} onDelete={onDelete} />
      </TabsContent>

      <TabsContent value="admin">
        <TaskGrid tasks={adminTasks} onEdit={onEdit} onDelete={onDelete} />
      </TabsContent>

      <TabsContent value="employee">
        <TaskGrid tasks={employeeTasks} onEdit={onEdit} onDelete={onDelete} />
      </TabsContent>

      <TabsContent value="calendar">
        <CalendarView
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          tasksForDate={getTasksForDate(selectedDate)}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      </TabsContent>
    </Tabs>
  );
};

export default TaskTabs;